<template>
    <button
        :class="[colorType === 'main' ? styles.btn_lither_main : styles.btn_lither_secondary]"
        :disabled="load"
        class="flex w-full min-w-max flex-row-reverse items-center justify-center text-sm md:flex-col md:text-base"
    >
        <slot/>
        <my-loader v-if="load"></my-loader>
        <BaseIcon
            v-else-if="icon"
            :icon="icon"
            class="ml-2"
        />
    </button>
</template>

<script>
import MyLoader from '../../MyLoader'
import BaseIcon from '../BaseIcon'

export default {
  name: 'BaseButtonLight',
  components: {
    BaseIcon,
    MyLoader
  },

  props: {
    icon: String,
    colorType: {
      type: String,
      default: 'main',
      validator (value) {
        return ['main', 'secondary'].includes(value)
      }
    },

    load: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      styles: window.myStyles
    }
  }
}
</script>

<style scoped>

</style>
